import styled from '@emotion/styled/macro';
import { Variables } from '../../../base';
import { statusTagToneColors } from '../claim-timeline.styles';
import { ITimelineEventStatusTagTone } from '../claim-timeline.types';
import {
    CdCard,
    CdFactCell,
    CdFactLabel,
    CdFactsGrid,
    CdFactMuted,
    CdFactValue,
    CdPanel,
    CdSectionCard,
    CdSectionTitle,
} from './timeline-detail-card.styles';

export const TxPanel = CdPanel;
export const TxCard = CdSectionCard;
export { CdSectionTitle as TxSectionTitle };
export const TxFactsGrid = CdFactsGrid;
export const TxFactCell = CdFactCell;
export const TxFactLabel = CdFactLabel;
export const TxFactValue = CdFactValue;
export const TxFactMuted = CdFactMuted;

export const TxResponseSection = styled(TxCard)`
    padding: 18px 24px 8px;
`;

export const TxResponseHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
`;

export const TxResponseCount = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 12px;
    color: ${Variables.ThemeLight.TextMild};
`;

export const TxResponseList = styled.div`
    position: relative;
`;

export const TxResponseRail = styled.div`
    position: absolute;
    left: 6px;
    top: 26px;
    bottom: 30px;
    width: 2px;
    background: ${Variables.ThemeLight.BackgroundB1};
`;

export const TxResponseRow = styled.div<{ $last?: boolean }>`
    position: relative;
    display: grid;
    grid-template-columns: 150px 1fr;
    gap: 20px;
    padding: 14px 0 14px 28px;
    border-bottom: ${({ $last }) => ($last ? 'none' : `1px solid ${Variables.ThemeLight.Border2}`)};
`;

export const TxResponseDot = styled.span<{ $tone: ITimelineEventStatusTagTone; $first?: boolean }>`
    position: absolute;
    left: 0;
    top: 20px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: ${({ $first, $tone }) =>
        $first ? statusTagToneColors($tone).dot : Variables.ThemeLight.Background3};
    border: 2px solid ${({ $tone }) => statusTagToneColors($tone).dot};
    box-sizing: border-box;
    box-shadow: ${({ $first, $tone }) =>
        $first ? `0 0 0 4px ${statusTagToneColors($tone).bg}` : 'none'};
`;

export const TxResponseMeta = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const TxResponseDate = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 12px;
    color: ${Variables.ThemeLight.TextMild};
    font-variant-numeric: tabular-nums;
`;

export const TxResponseBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
`;

export const TxResponseMessage = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 15px;
    font-weight: 500;
    line-height: 1.4;
    color: ${Variables.ThemeLight.TextStrong};
    text-wrap: pretty;
`;

export const TxResponseMetaRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
`;

export const TxResponseMetaItem = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-family: ${Variables.Fonts.calibre};
    font-size: 12px;
    color: ${Variables.ThemeLight.TextMild};
`;

export const TxCodePill = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 12px;
    background: ${Variables.ThemeLight.NeutralMild1};
    border: 1px solid ${Variables.ThemeLight.Border2};
    padding: 2px 7px;
    border-radius: 4px;
    color: ${Variables.ThemeLight.TextStrong};
`;

export const TxEdiSection = styled(TxCard)``;
